<template>
    <c-modal v-model="isModalOpen" title="Edit Preview" size="sm" @ok="handleClose" @close="handleClose">
        <validation-observer ref="editFormRef">
            <div class="form-group">
                <validation-provider v-slot="{ failed }" rules="required">
                    <c-input
                        v-model="preview.label"
                        label="Name"
                        label-class="text-muted small2"
                        class="mb-2"
                        required
                        :error="failed"
                        error-msg="Enter the name of the preview"
                    />
                </validation-provider>
            </div>
        </validation-observer>
        <template #modal-footer>
            <div class="d-flex justify-content-between w-100">
                <c-button text="Cancel" variant="secondary" @click="handleClose" />
                <c-button text="Save" variant="primary" @click="savePreview" />
            </div>
        </template>
    </c-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import CButton from '@/components/shared/CButton';
import CModal from '@/components/CModal.vue';
import CInput from '@/components/shared/CInput';

type Preview = {
    label: string;
    value: string;
};

const emit = defineEmits(['save']);

const isModalOpen = ref(false);
const preview = ref({ label: '', value: '' });

const openModal = (previewData: Preview) => {
    preview.value = { ...previewData };
    isModalOpen.value = true;
};

const handleClose = () => {
    isModalOpen.value = false;
    preview.value = { label: '', value: '' };
};

const savePreview = () => {
    emit('save', preview.value);
    handleClose();
};

defineExpose({
    openModal
});
</script>
